<app-tab-toolbar [tabId]="'audit1'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges && !isCarriedForward" [showOtherMeasurement]="true" [otherMeasurement]="otherMeasurement" [showKeywordsToggle]="true" [keywordsVisible]="showKeywords" (yearChange)="onYearChange($event)" (otherMeasurementChange)="onOtherMeasurementChange($event)" (keywordsVisibleChange)="showKeywords = $event" (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>warning</mat-icon>
      @if (isCarriedForward) {
        <span>There is no data for the selected year. Some fields are shown from a previous year.</span>
      } @else {
        <span>There is no data for the selected year</span>
      }
    </div>
  }
</app-tab-toolbar>

<div class="audit-content" [formGroup]="form" [appReadOnlyTab]="'audit1'">
  <!-- Audit Firms Section -->
  <section class="section-container nrg-border-radius-second-level">
    <div class="audit-grid">
      <!-- Headers -->
      <div class="grid-label"></div>
      <div class="grid-header">Audit Firm 1</div>
      <div class="grid-header">Audit Firm 2</div>

      <!-- Audit Firm -->
      <div class="grid-label">Audit Firm</div>
      <div class="grid-field">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Audit Firm</mat-label>
          <input matInput
                 [formControl]="firm1SearchControl"
                 [matAutocomplete]="autoFirm1"
                 placeholder="Type to search...">
          @if (firm1SearchControl.value && !isReadOnly()) {
            <button matSuffix mat-icon-button (click)="clearFirm(1)" type="button" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          }
          <mat-autocomplete #autoFirm1="matAutocomplete"
                            (optionSelected)="onFirmSelected(1, $event.option.value)">
            @for (firm of filteredFirms1; track firm.id) {
              <mat-option [value]="firm">{{ firm.name }}</mat-option>
            }
            @if (filteredFirms1.length === 0 && firm1SearchControl.value && firm1SearchControl.value.length >= 2) {
              <mat-option disabled>No results found</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        @if (otherMeasurement && getOtherFirmName(1)) {
          <div class="comparison-hint">{{ getOtherFirmName(1) }}</div>
        }
      </div>
      <div class="grid-field">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Audit Firm</mat-label>
          <input matInput
                 [formControl]="firm2SearchControl"
                 [matAutocomplete]="autoFirm2"
                 placeholder="Type to search...">
          @if (firm2SearchControl.value && !isReadOnly()) {
            <button matSuffix mat-icon-button (click)="clearFirm(2)" type="button" tabindex="-1">
              <mat-icon>close</mat-icon>
            </button>
          }
          <mat-autocomplete #autoFirm2="matAutocomplete"
                            (optionSelected)="onFirmSelected(2, $event.option.value)">
            @for (firm of filteredFirms2; track firm.id) {
              <mat-option [value]="firm">{{ firm.name }}</mat-option>
            }
            @if (filteredFirms2.length === 0 && firm2SearchControl.value && firm2SearchControl.value.length >= 2) {
              <mat-option disabled>No results found</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        @if (otherMeasurement && getOtherFirmName(2)) {
          <div class="comparison-hint">{{ getOtherFirmName(2) }}</div>
        }
      </div>

      <!-- Auditor 1 -->
      <div class="grid-label">Auditor 1</div>
      <div class="grid-field" formGroupName="firm1">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Auditor 1</mat-label>
          <input matInput formControlName="auditor1" appTextNormalize />
        </mat-form-field>
        @if (otherMeasurement && otherFirm1Data?.auditor1) {
          <div class="comparison-hint">{{ otherFirm1Data?.auditor1 }}</div>
        }
      </div>
      <div class="grid-field" formGroupName="firm2">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Auditor 1</mat-label>
          <input matInput formControlName="auditor1" appTextNormalize />
        </mat-form-field>
        @if (otherMeasurement && otherFirm2Data?.auditor1) {
          <div class="comparison-hint">{{ otherFirm2Data?.auditor1 }}</div>
        }
      </div>

      <!-- Auditor 2 -->
      <div class="grid-label">Auditor 2</div>
      <div class="grid-field" formGroupName="firm1">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Auditor 2</mat-label>
          <input matInput formControlName="auditor2" appTextNormalize />
        </mat-form-field>
        @if (otherMeasurement && otherFirm1Data?.auditor2) {
          <div class="comparison-hint">{{ otherFirm1Data?.auditor2 }}</div>
        }
      </div>
      <div class="grid-field" formGroupName="firm2">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Auditor 2</mat-label>
          <input matInput formControlName="auditor2" appTextNormalize />
        </mat-form-field>
        @if (otherMeasurement && otherFirm2Data?.auditor2) {
          <div class="comparison-hint">{{ otherFirm2Data?.auditor2 }}</div>
        }
      </div>

      <!-- Currency -->
      <div class="grid-label">Currency</div>
      <div class="grid-field" formGroupName="firm1">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Currency</mat-label>
          <mat-select formControlName="currencyId">
            <mat-option value="">(None)</mat-option>
            @for (currency of currencies; track currency.id) {
              <mat-option [value]="currency.id">{{ currency.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (otherMeasurement && getOtherCurrencyName(1)) {
          <div class="comparison-hint">{{ getOtherCurrencyName(1) }}</div>
        }
      </div>
      <div class="grid-field" formGroupName="firm2">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Currency</mat-label>
          <mat-select formControlName="currencyId">
            <mat-option value="">(None)</mat-option>
            @for (currency of currencies; track currency.id) {
              <mat-option [value]="currency.id">{{ currency.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (otherMeasurement && getOtherCurrencyName(2)) {
          <div class="comparison-hint">{{ getOtherCurrencyName(2) }}</div>
        }
      </div>

      <!-- Signature Date -->
      <div class="grid-label">Signature Date</div>
      <div class="grid-field" formGroupName="firm1">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Signature Date</mat-label>
          <input matInput [matDatepicker]="sigDatePicker1" formControlName="signatureDate">
          <mat-datepicker-toggle matIconSuffix [for]="sigDatePicker1"></mat-datepicker-toggle>
          <mat-datepicker #sigDatePicker1></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="grid-field" formGroupName="firm2">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>Signature Date</mat-label>
          <input matInput [matDatepicker]="sigDatePicker2" formControlName="signatureDate">
          <mat-datepicker-toggle matIconSuffix [for]="sigDatePicker2"></mat-datepicker-toggle>
          <mat-datepicker #sigDatePicker2></mat-datepicker>
        </mat-form-field>
      </div>

      <!-- State -->
      <div class="grid-label">State</div>
      <div class="grid-field" formGroupName="firm1">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>State</mat-label>
          <input matInput formControlName="state" />
        </mat-form-field>
      </div>
      <div class="grid-field" formGroupName="firm2">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>State</mat-label>
          <input matInput formControlName="state" />
        </mat-form-field>
      </div>

      <!-- City -->
      <div class="grid-label">City</div>
      <div class="grid-field" formGroupName="firm1">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" />
        </mat-form-field>
      </div>
      <div class="grid-field" formGroupName="firm2">
        <mat-form-field appearance="fill" class="form-field">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" />
        </mat-form-field>
      </div>

      <!-- Audit Firm Tenure -->
      <div class="grid-label">Audit Firm Tenure</div>
      <div class="grid-field" formGroupName="firm1">
        <div class="tenure-row">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Year</mat-label>
            <input matInput type="number" inputmode="numeric" formControlName="auditFirmTenure" />
          </mat-form-field>
          @if (firm1Group.get('auditFirmTenure')?.value) {
            <span class="tenure-start">{{ +selectedYear - firm1Group.get('auditFirmTenure')!.value + 1 }} years</span>
          }
        </div>
      </div>
      <div class="grid-field" formGroupName="firm2">
        <div class="tenure-row">
          <mat-form-field appearance="fill" class="form-field">
            <mat-label>Year</mat-label>
            <input matInput type="number" inputmode="numeric" formControlName="auditFirmTenure" />
          </mat-form-field>
          @if (firm2Group.get('auditFirmTenure')?.value) {
            <span class="tenure-start">{{ +selectedYear - firm2Group.get('auditFirmTenure')!.value + 1 }} years</span>
          }
        </div>
      </div>
    </div>

    @if (showKeywords) {
      <div class="keywords-section" formGroupName="keywords">
        <div class="section-header">
          <span>Keywords</span>
        </div>
        <div class="keywords-fields">
          <app-keyword-input name="main" label="Main" />
          <app-keyword-input name="comment" label="Comment" />
        </div>
      </div>
    }
  </section>

  <!-- Audit Fees Section -->
  @if (auditFeeRows.length > 0) {
    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        <span>Audit Fees</span>
      </div>
      <div class="audit-grid">
        <div class="grid-label grid-col-header"></div>
        <div class="grid-col-header grid-fee-field">Firm 1</div>
        <div class="grid-col-header grid-fee-field">Firm 2</div>

        @for (row of auditFeeRows; track row.category.id) {
          <div class="fee-row">
            <div class="grid-label fee-row-label">{{ row.category.name }}</div>
            <div class="grid-field grid-fee-field">
              <mat-form-field appearance="fill" class="form-field">
                <input matInput type="text" inputmode="decimal" appNumberFormat [formControl]="row.firm1Control" />
              </mat-form-field>
              @if (otherMeasurement) {
                @let otherVal = getOtherFeeValue(row.category.id, 1);
                @if (otherVal !== null) {
                  <div class="comparison-hint comparison-hint-fee">{{ formatNumber(otherVal) }}</div>
                }
              }
            </div>
            <div class="grid-field grid-fee-field">
              <mat-form-field appearance="fill" class="form-field">
                <input matInput type="text" inputmode="decimal" appNumberFormat [formControl]="row.firm2Control" />
              </mat-form-field>
              @if (otherMeasurement) {
                @let otherVal = getOtherFeeValue(row.category.id, 2);
                @if (otherVal !== null) {
                  <div class="comparison-hint comparison-hint-fee">{{ formatNumber(otherVal) }}</div>
                }
              }
            </div>
          </div>
        }

        <div class="grid-label grid-total">Audit Fees Total</div>
        <div class="grid-field grid-total">{{ formatNumber(auditFeesTotal1) }}</div>
        <div class="grid-field grid-total">{{ formatNumber(auditFeesTotal2) }}</div>
      </div>
    </section>
  }

  <!-- Related Fees Section -->
  @if (relatedFeeRows.length > 0) {
    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        <span>Related Fees</span>
      </div>
      <div class="audit-grid">
        <div class="grid-label grid-col-header"></div>
        <div class="grid-col-header grid-fee-field">Firm 1</div>
        <div class="grid-col-header grid-fee-field">Firm 2</div>

        @for (row of relatedFeeRows; track row.category.id) {
          <div class="fee-row">
            <div class="grid-label fee-row-label">{{ row.category.name }}</div>
            <div class="grid-field grid-fee-field">
              <mat-form-field appearance="fill" class="form-field">
                <input matInput type="text" inputmode="decimal" appNumberFormat [formControl]="row.firm1Control" />
              </mat-form-field>
              @if (otherMeasurement) {
                @let otherVal = getOtherFeeValue(row.category.id, 1);
                @if (otherVal !== null) {
                  <div class="comparison-hint comparison-hint-fee">{{ formatNumber(otherVal) }}</div>
                }
              }
            </div>
            <div class="grid-field grid-fee-field">
              <mat-form-field appearance="fill" class="form-field">
                <input matInput type="text" inputmode="decimal" appNumberFormat [formControl]="row.firm2Control" />
              </mat-form-field>
              @if (otherMeasurement) {
                @let otherVal = getOtherFeeValue(row.category.id, 2);
                @if (otherVal !== null) {
                  <div class="comparison-hint comparison-hint-fee">{{ formatNumber(otherVal) }}</div>
                }
              }
            </div>
          </div>
        }

        <div class="grid-label grid-total">Related Fees Total</div>
        <div class="grid-field grid-total">{{ formatNumber(relatedFeesTotal1) }}</div>
        <div class="grid-field grid-total">{{ formatNumber(relatedFeesTotal2) }}</div>
      </div>
    </section>
  }

  <!-- Tax Fees Section -->
  @if (taxFeeRows.length > 0) {
    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        <span>Tax Fees</span>
      </div>
      <div class="audit-grid">
        <div class="grid-label grid-col-header"></div>
        <div class="grid-col-header grid-fee-field">Firm 1</div>
        <div class="grid-col-header grid-fee-field">Firm 2</div>

        @for (row of taxFeeRows; track row.category.id) {
          <div class="fee-row">
            <div class="grid-label fee-row-label">{{ row.category.name }}</div>
            <div class="grid-field grid-fee-field">
              <mat-form-field appearance="fill" class="form-field">
                <input matInput type="text" inputmode="decimal" appNumberFormat [formControl]="row.firm1Control" />
              </mat-form-field>
              @if (otherMeasurement) {
                @let otherVal = getOtherFeeValue(row.category.id, 1);
                @if (otherVal !== null) {
                  <div class="comparison-hint comparison-hint-fee">{{ formatNumber(otherVal) }}</div>
                }
              }
            </div>
            <div class="grid-field grid-fee-field">
              <mat-form-field appearance="fill" class="form-field">
                <input matInput type="text" inputmode="decimal" appNumberFormat [formControl]="row.firm2Control" />
              </mat-form-field>
              @if (otherMeasurement) {
                @let otherVal = getOtherFeeValue(row.category.id, 2);
                @if (otherVal !== null) {
                  <div class="comparison-hint comparison-hint-fee">{{ formatNumber(otherVal) }}</div>
                }
              }
            </div>
          </div>
        }

        <div class="grid-label grid-total">Tax Fees Total</div>
        <div class="grid-field grid-total">{{ formatNumber(taxFeesTotal1) }}</div>
        <div class="grid-field grid-total">{{ formatNumber(taxFeesTotal2) }}</div>
      </div>
    </section>
  }

  <!-- Other Fees Section -->
  @if (otherFeeRows.length > 0) {
    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        <span>Other Fees</span>
      </div>
      <div class="audit-grid">
        <div class="grid-label grid-col-header"></div>
        <div class="grid-col-header grid-fee-field">Firm 1</div>
        <div class="grid-col-header grid-fee-field">Firm 2</div>

        @for (row of otherFeeRows; track row.category.id) {
          <div class="fee-row">
            <div class="grid-label fee-row-label">{{ row.category.name }}</div>
            <div class="grid-field grid-fee-field">
              <mat-form-field appearance="fill" class="form-field">
                <input matInput type="text" inputmode="decimal" appNumberFormat [formControl]="row.firm1Control" />
              </mat-form-field>
              @if (otherMeasurement) {
                @let otherVal = getOtherFeeValue(row.category.id, 1);
                @if (otherVal !== null) {
                  <div class="comparison-hint comparison-hint-fee">{{ formatNumber(otherVal) }}</div>
                }
              }
            </div>
            <div class="grid-field grid-fee-field">
              <mat-form-field appearance="fill" class="form-field">
                <input matInput type="text" inputmode="decimal" appNumberFormat [formControl]="row.firm2Control" />
              </mat-form-field>
              @if (otherMeasurement) {
                @let otherVal = getOtherFeeValue(row.category.id, 2);
                @if (otherVal !== null) {
                  <div class="comparison-hint comparison-hint-fee">{{ formatNumber(otherVal) }}</div>
                }
              }
            </div>
          </div>
        }

        <div class="grid-label grid-total">Other fees Total</div>
        <div class="grid-field grid-total">{{ formatNumber(otherFeesTotal1) }}</div>
        <div class="grid-field grid-total">{{ formatNumber(otherFeesTotal2) }}</div>
      </div>
    </section>
  }

  <!-- Grand Total -->
  @if (auditFeeRows.length > 0 || relatedFeeRows.length > 0 || taxFeeRows.length > 0 || otherFeeRows.length > 0) {
    <section class="section-container nrg-border-radius-second-level">
      <div class="audit-grid">
        <div class="grid-label grid-grand-total">Grand Total</div>
        <div class="grid-field grid-grand-total">{{ formatNumber(auditFeesTotal1 + relatedFeesTotal1 + taxFeesTotal1 + otherFeesTotal1) }}</div>
        <div class="grid-field grid-grand-total">{{ formatNumber(auditFeesTotal2 + relatedFeesTotal2 + taxFeesTotal2 + otherFeesTotal2) }}</div>
      </div>
    </section>
  }
</div>

<ngx-spinner name="primary" type="ball-spin-clockwise" [fullScreen]="false" size="medium" />
